import { Component } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe, Location } from '@angular/common';
import Swal from 'sweetalert2'
import { BASE_IMAGE_URL, PAGELENGTH } from 'src/app/endpoints';
import { UserDataService } from 'src/app/shared/service/userData/user-data.service';
import { RouterLink } from '@angular/router';
import { SHARED_IMPORTS } from 'src/app/shared-imports';
declare var bootstrap: any;
import { MatTableDataSource } from '@angular/material/table';
import { HasRoleDirective } from 'src/app/shared/directive/has-role.directive';
import { MatPaginator } from '@angular/material/paginator';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { LabTestService } from 'src/app/shared/service/labTest/lab-test.service';
import { MedicalTestService } from 'src/app/shared/service/labTest/medical-test.service';

@Component({
  selector: 'app-medical-tests',
  imports: [
    SHARED_IMPORTS,
    ReactiveFormsModule,
    CommonModule,
    DatePipe,
    RouterLink,
    HasRoleDirective,
  ],
  templateUrl: './medical-tests.component.html',
  styleUrl: './medical-tests.component.scss'
})
export class MedicalTestsComponent {


  genders: any = [{ _id: 'Hospital', name: "Hospital" }, { _id: "Home", name: "Home" }];

  // =============================
  // 🔹 All Variables on Top
  // =============================
  formType: string = 'Add';
  categoryModal: any;
  detailsModal: any;
  selectedItem: any = null;
  startpoint = 0;
  search: any;
  totalLoaded = 0;
  total = 0;
  pageNo = 0;
  categoryRes: any;
  categoryId: any;
  pageSize: number = 10;
  name: any;
  displayedColumns: string[] = ['position',
    'medicalTestId',
    'doctor',
    'person',
   'testName',
    'status',
    'tests',
    'otherTests',
    'action'];
  dataSource = new MatTableDataSource<any>([]);
  isCompanyLoggedIn: boolean = false;
  debounceTimer: any = null;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('fileInput') fileInput!: ElementRef;

  categoryForm = new FormGroup({
    _id: new FormControl(''),
    name: new FormControl('', Validators.required),
    Status: new FormControl(1),
    Tests: new FormControl([]),        // store full array
    OtherTest: new FormControl([])
  });

  // =============================
  // 🔹 Constructor
  // =============================
  constructor(
    private _medical: MedicalTestService,
    private _lab: LabTestService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public userDataService: UserDataService
  ) {
    this.setDisplayedColumns();
  }

  // =============================
  // 🔹 Lifecycle Hooks
  // =============================
  ngOnInit(): void {
    this.getCompanyData();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    const modalElement = document.getElementById('wardModal');
    if (modalElement) {
      this.categoryModal = new bootstrap.Modal(modalElement);
    }
    const detailsModalElement = document.getElementById('detailsModal');
    if (detailsModalElement) {
      this.detailsModal = new bootstrap.Modal(detailsModalElement);
    }
  }

  // =============================
  // 🔹 Column Setup
  // =============================
  setDisplayedColumns(): void {
    this.displayedColumns = [
      'position',
      'medicalTestId',
      'doctor',
      'person',
      'testName',
      'status',
      'tests',
      'otherTests',
      'action'
    ];
  }

  // =============================
  // 🔹 Utility Methods
  // =============================
  onSearchChange(event: any) {
    const value = event.target.value.trim();
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.name = value || undefined;
      this.getAllCategories(null);
    }, 200);
  }

  getImg(imgPath: any) {
    if (!imgPath) return '';

    if (typeof imgPath === 'string') {
      const trimmed = imgPath.trim();
      if (!trimmed) return '';
      return trimmed.startsWith('http://') || trimmed.startsWith('https://')
        ? trimmed
        : BASE_IMAGE_URL.replace(/\/$/, '') + '/' + trimmed.replace(/^\//, '');
    }

    if (typeof imgPath === 'object') {
      const path = imgPath.url || imgPath.path || imgPath.file || imgPath.name || imgPath.filename || imgPath.fileName;
      if (!path) return '';
      const trimmed = String(path).trim();
      if (!trimmed) return '';
      return trimmed.startsWith('http://') || trimmed.startsWith('https://')
        ? trimmed
        : BASE_IMAGE_URL.replace(/\/$/, '') + '/' + trimmed.replace(/^\//, '');
    }

    return '';
  }

  clearForm() {
    this.categoryForm.reset();
    if (this.fileInput) this.fileInput.nativeElement.value = '';
  }


  deleteItem(id: string) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn btn-secondary'
      },
      buttonsStyling: false
    });

    swalWithBootstrapButtons.fire({
      title: 'Delete this test?',
      text: 'This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();

        this._medical.deleteMedicalTest({ _id: id }).subscribe({
          next: (res: any) => {
            this.spinner.hide();

            if (res.success) {
              this.toastr.success(res.message);
              this.closeDetailsModal();
              this.getAllCategories(null);
            } else {
              this.toastr.error(res.message);
            }
          },
          error: (err) => {
            this.spinner.hide();
            this.toastr.error(err.message);
          }
        });
      }
    });
  }

updateOtherTest(index: number, field: string, event: Event) {
  const input = event.target as HTMLInputElement;
  const value = input.value;

  const otherTests = this.categoryForm.value.OtherTest || [];
  const updated = [...otherTests];

  updated[index] = {
    ...updated[index],
    [field]: field === 'price' ? Number(value) : value
  };

  this.categoryForm.patchValue({
    OtherTest: updated
  });
}
  // =============================
  // 🔹 Modal Logic
  // =============================
  openModel(type: string, categoryId: any) {
    if (type === 'Edit') {
      this.closeDetailsModal();
    }

    this.formType = type;
    this.categoryId = categoryId;

    this.clearForm();

    if (type === 'Edit' && categoryId) {
      let rowData: any;

      if (typeof categoryId === 'object') {
        rowData = categoryId;
      } else {
        rowData = this.dataSource.data.find((item: any) => item._id === categoryId);
      }


      if (rowData) {
        let testData = null;

        // Priority: Tests → OtherTest
        if (rowData.Tests && rowData.Tests.length > 0) {
          testData = rowData.Tests[0];
        } else if (rowData.OtherTest && rowData.OtherTest.length > 0) {
          testData = rowData.OtherTest[0];
        }

        this.categoryForm.patchValue({
          _id: rowData._id,
          name: rowData.name || '',
          Status: Number(rowData.Status ?? 1),
          Tests: rowData.Tests || [],
          OtherTest: rowData.OtherTest || []
        });

        this.categoryId = rowData._id;
      }


    }

    this.categoryModal.show();
  }

  hideModel() {
    this.clearForm();
    this.categoryModal.hide();
  }

  openDetailsModal(item: any) {
    this.selectedItem = item;
    this.detailsModal.show();
  }

  closeDetailsModal() {
    this.selectedItem = null;
    this.detailsModal.hide();
  }

  uploadImage(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    // File type validation
    if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
      this.toastr.info("Only JPG, JPEG and PNG images are allowed.");
      event.target.value = "";
      return;
    }

    // Check aspect ratio
    const img = new Image();
    img.src = URL.createObjectURL(file);
    // img.onload = () => {
    //   this.categoryForm.patchValue({ category_image: file });

    //   // const aspectRatio = img.width / img.height;
    //   // if (Math.abs(aspectRatio - 16 / 9) < 0.01) {   // 16:9 ratio (allowing small tolerance)
    //   // } else {
    //   //   this.toastr.error("Image aspect ratio must be 16:9.");
    //   //   event.target.value = "";
    //   // }
    // };
  }




  // =============================
  // 🔹 Company Data Check
  // =============================
  getCompanyData() {
    const userData = this.userDataService.getData();
    const companyData = userData.company;
    this.isCompanyLoggedIn = !!companyData;
    this.getAllCategories(null);
  }

  // =============================
  // 🔹 Category Fetch
  // =============================
  getAllCategories(event: any) {
    this.spinner.show();

    if (!event) {
      this.pageNo = 0;
      this.startpoint = 0;
      this.pageSize = this.pageSize || PAGELENGTH;
      this.dataSource.data = [];
      this.totalLoaded = 0;
    }

    if (event?.pageSize && event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.pageNo = 0;
      this.startpoint = 0;
      this.dataSource.data = [];
      this.totalLoaded = 0;
    }

    if (event?.pageIndex !== undefined) {
      this.pageNo = event.pageIndex;
      this.startpoint = this.pageNo * (this.pageSize || PAGELENGTH);
    }

    const data: any = {
      startpoint: this.startpoint,
      limit: this.pageSize || PAGELENGTH,
    };

    if (this.name) data.name = this.name;
    if (this.isCompanyLoggedIn) data.isBlocked = false;

    this._medical.getAllMedicalTests(data).subscribe({
      next: (result) => {
        this.spinner.hide();
        if (result.success) {
          this.total = result.total ?? 0;
          this.dataSource = new MatTableDataSource(result.data || []);


          setTimeout(() => {
            if (this.paginator) {
              this.paginator.pageIndex = this.pageNo;
              this.paginator.length = this.total;
              this.paginator.pageSize = this.pageSize ?? PAGELENGTH;
            }
          }, 0);
        }
      },
      error: (e: any) => {
        this.spinner.hide();
        const errorMsg =
          e.status === 0 ? 'Server not reachable.' : e.message || 'Unexpected error.';
        this.toastr.error(errorMsg, 'Error');
      },
    });
  }

  // =============================
  // 🔹 Submit Handler
  // =============================


resultFiles: File[] = [];

onFileSelect(event: Event, type: string) {
  const input = event.target as HTMLInputElement;

  if (!input.files) return;

  const files: File[] = Array.from(input.files); // ✅ correct typing

  if (type === 'test') {
   this.resultFiles = files;
  } else {
     this.resultFiles = files;
  }
}

  submit() {
    if (this.categoryForm.invalid) return;

    this.spinner.show();

    const payload = {
      _id: this.categoryId,
      name: this.categoryForm.value.name,
      Tests: this.categoryForm.value.Tests,
      OtherTest: this.categoryForm.value.OtherTest
    };

    const formData = new FormData();

    formData.append('name', payload.name);
    formData.append('Tests', JSON.stringify(payload.Tests));
    formData.append('OtherTest', JSON.stringify(payload.OtherTest));
    formData.append('Status', String(this.categoryForm.value.Status));

 
// Append result files
this.resultFiles.forEach(file => {
  formData.append('Result_Files', file);
});

    if (this.formType === 'Edit') {
      formData.append('_id', payload._id);
    }
    if (this.formType === 'Add') {
      this._medical.addMedicalTest(formData).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res.success) {
            this.toastr.success(res.message);
            this.hideModel();
            this.getAllCategories(null);
          } else {
            this.toastr.error(res.message);
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.toastr.error(err.message);
        }
      });

    } else {
      this._medical.updateMedicalTest(formData).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res.success) {
            this.toastr.success(res.message);
            this.hideModel();
            this.getAllCategories(null);
          } else {
            this.toastr.error(res.message);
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.toastr.error(err.message);
        }
      });
    }
  }

  //       deleteItem(id: string) {
  //   if (!confirm('Are you sure?')) return;

  //   this._lab.delete(id).subscribe(() => {
  //     this.getAllCategories(null);
  //   });
  // }
  // =============================
  // 🔹 Block/Unblock Handler
  // =============================
  onToggleClick(element: any) {
    const currentStatus = element.isBlocked;
    const newStatus = !currentStatus;
    const action = newStatus ? 'Block' : 'Unblock';

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: `${action} this category?`,
        text: `This will ${action.toLowerCase()} the category.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `${action}`,
        cancelButtonText: 'Cancel',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          // this.wardService
          //   .enableDisableCompany({ _id: element._id, isBlocked: newStatus })
          //   .subscribe({
          //     next: (v: any) => {
          //       if (v.success) {
          //         element.isBlocked = newStatus;
          //         this.toastr.success(`Category ${action.toLowerCase()}ed successfully.`);
          //       } else {
          //         this.toastr.error(v.message, 'Error');
          //       }
          //     },
          //     error: (e: any) => {
          //       this.toastr.error(e.message, 'Error');
          //     },
          //   });
        }
      });
    return false;
  }

}
